// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"80dee7fc","453":"98bab002","732":"a72d79d9","977":"83d65e47"}[chunkId] + ".chunk.js";
};